import { heavyCalcHandlers, } from './handlers.js';
// undefined: not attempted yet, null: unavailable (falls back to main thread)
let worker;
const pending = new Map();
let nextId = 0;
const runOnMainThread = (p) => Promise.resolve().then(p.fallback).then(p.resolve, p.reject);
const failover = () => {
    worker?.terminate();
    worker = null;
    for (const [id, p] of pending) {
        pending.delete(id);
        runOnMainThread(p);
    }
};
const getWorker = () => {
    if (worker !== undefined) {
        return worker;
    }
    try {
        if (typeof Worker === 'undefined') {
            worker = null;
            return worker;
        }
        const w = new Worker(new URL('./calc.worker.js', import.meta.url), {
            type: 'module',
        });
        w.onmessage = (e) => {
            const p = pending.get(e.data.id);
            if (p == null) {
                return;
            }
            pending.delete(e.data.id);
            if (e.data.error != null) {
                p.reject(new Error(e.data.error));
            }
            else {
                p.resolve(e.data.result);
            }
        };
        w.onerror = failover;
        w.onmessageerror = failover;
        worker = w;
    }
    catch {
        worker = null;
    }
    return worker;
};
const call = (method, args) => new Promise((resolve, reject) => {
    const p = {
        resolve: resolve,
        reject,
        fallback: () => heavyCalcHandlers[method](...args),
    };
    const w = getWorker();
    if (w == null) {
        runOnMainThread(p);
        return;
    }
    const id = nextId++;
    pending.set(id, p);
    try {
        // Web Worker postMessage does not accept a window targetOrigin.
        // oxlint-disable-next-line unicorn/require-post-message-target-origin
        w.postMessage({ id, method, args });
    }
    catch {
        pending.delete(id);
        runOnMainThread(p);
    }
});
export const workerHeavy = Object.fromEntries(Object.keys(heavyCalcHandlers).map((method) => [
    method,
    (...args) => call(method, args),
]));
//# sourceMappingURL=worker-client.js.map